import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { List } from 'immutable'
import { injectIntl } from 'react-intl'
import AppLayout from 'components/Layout/App'
import * as ROUTE from 'constants/appRouting'
import Logout from 'routes/App/Logout'
import RoleHelper from 'helpers/role'
import NotFound from 'routes/Exception/routes/404'
import { fetchProfile, setCurrentAppName } from 'reducers/profile/reducer'
import { checkPathInApps } from 'helpers/apps-menu'
import { getProfileMenuItem } from 'helpers/menuProfile'
import message from 'components/Layout/App/Sidenav/translate'
import ProfilePersonalInfo from 'components/Profile/ProfilePersonalInfo'
import ProfileNotifications from 'components/Profile/ProfileNotifications'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import User from './User'
import Licensee from './Licensee'
import Application from './Application'
import SisenseDashboard from './SisenseDashboard'
import Site from './Site'
import SiteGroup from './SiteGroup'
import Locus from './Locus'
import LocusGroup from './LocusGroup'
import UserGroup from './UserGroup'
import Audit from './Audit'
import Translations from './Translations'
import Apps from './Apps'
import LicenseeApplication from './LicenseeApplication'
import JobsWorkflowAdmin from './JobsAdmin'
import FeatureFlags from './FeatureFlags/FeatureFlags'

class App extends React.Component {
  componentDidMount() {
    const { fetchProfile } = this.props

    fetchProfile()
  }

  getCurrentApp = () => {
    const {
      location: { pathname },
      intl: { formatMessage },
      applications,
      setCurrentAppName,
      currentAppName,
    } = this.props
    const currentApp = checkPathInApps(pathname, applications.toArray())

    if (currentApp && currentApp.appName !== currentAppName) {
      setCurrentAppName(currentApp.appName)
    }

    if (!currentApp && pathname !== ROUTE.APPS) {
      const menuItem = getProfileMenuItem(pathname)
      const itemName = menuItem && menuItem.name
      const menuItemTitle =
        itemName && message[itemName] && formatMessage(message[itemName])

      if (menuItem && menuItemTitle) {
        setCurrentAppName(menuItemTitle)
      }
    }

    if (pathname === ROUTE.APPS) {
      setCurrentAppName(formatMessage(message.appsStore))
    }
  }

  render() {
    const {
      profileId,
      history,
      roleLevel,
      location: { pathname },
      isAccessDenied,
      allowedToManageWorkflows,
    } = this.props

    if (!profileId) {
      return null
    }

    this.getCurrentApp()

    return (
      <AppLayout
        history={history}
        roleLevel={roleLevel}
        locationPath={pathname}
        role={RoleHelper.ROLE_USER_LEVEL}
        isAccessDenied={isAccessDenied}
        allowedToManageWorkflows={allowedToManageWorkflows}>
        <Switch>
          <Route path={ROUTE.APPS} component={Apps} />
          <Route
            path={ROUTE.PROFILE_PERSONAL_INFO}
            component={ProfilePersonalInfo}
          />
          <Route
            path={ROUTE.PROFILE_NOTIFICATIONS}
            component={ProfileNotifications}
          />
          <Route
            path={ROUTE.APPLICATION_EDIT_PATTERN}
            component={Application}
          />
          <Route path={ROUTE.LICENSEE_EDIT_PATTERN} component={Licensee} />
          <Route
            path={ROUTE.LICENSEE_APPLICATION_EDIT_PATTERN}
            component={LicenseeApplication}
          />
          <Route
            path={ROUTE.SISENSE_EDIT_PATTERN}
            component={SisenseDashboard}
          />
          <Route path={ROUTE.USER_EDIT_PATTERN} component={User} />
          <Route path={ROUTE.USER_GROUP_EDIT_PATTERN} component={UserGroup} />
          <Route path={ROUTE.SITE_EDIT_PATTERN} component={Site} />
          <Route path={ROUTE.SITE_GROUP_EDIT_PATTERN} component={SiteGroup} />
          <Route path={ROUTE.LOCUS_EDIT_PATTERN} component={Locus} />
          <Route path={ROUTE.LOCUS_GROUP_EDIT_PATTERN} component={LocusGroup} />
          <Route
            path={ROUTE.JOBS_WORKFLOW_ADMIN}
            component={JobsWorkflowAdmin}
          />
          <Route path={ROUTE.AUDIT} component={Audit} />
          <Route path={ROUTE.TRANSLATIONS} component={Translations} />
          <Route exact path={ROUTE.LOGOUT} component={Logout} />
          <Route
            path={ROUTE.FEATURE_FLAGS_EDIT_PATTERN}
            component={FeatureFlags}
          />
          <Route component={NotFound} />
        </Switch>
      </AppLayout>
    )
  }
}

App.propTypes = {
  roleLevel: PropTypes.number.isRequired,
  profileId: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  intl: REACT_INTL_PROP_TYPE.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  fetchProfile: PropTypes.func,
  applications: PropTypes.object,
  currentAppName: PropTypes.string,
  setCurrentAppName: PropTypes.func,
}

App.defaultProps = {
  location: {
    pathname: '',
  },
  applications: List([]),
  currentAppName: '',
  setCurrentAppName: () => {},
  fetchProfile: () => {},
}

const enhance = connect(
  state => ({
    applications: state.getIn(['profile', 'profile', 'applications']),
    roleLevel: state.getIn(['profile', 'roleLevel']),
    profileId: state.getIn(['profile', 'profile', 'id']),
    currentAppName: state.getIn(['profile', 'currentAppName']),
    isAccessDenied: state.getIn(['layout', 'isAccessDenied']),
    allowedToManageWorkflows: state.getIn([
      'profile',
      'profile',
      'grantedManageWorkflows',
    ]),
  }),
  {
    fetchProfile,
    setCurrentAppName,
  },
)

export default enhance(withRouter(injectIntl(App)))
